var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntensidadInstrumentalBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,2C115.77,2,2,115.75,2,256.06S115.77,510,256,510,510.05,396.28,510.05,256.06,396.31,2,256,2ZM83.46,83.49A243.93,243.93,0,0,1,500,253.2H424.68a5,5,0,0,0-4.35,2.53l-7.59,13.4L401,220.83a5,5,0,0,0-9.76.21L374.9,303.62l-14.33-37.47V206.51H338.65l-16.23-44.33a5,5,0,0,0-9.56.55l-10.5,43.78h-4V190.57H278.14V178h-9.55V88H242.84v90h-9.55v12.57H213.07v15.94H171.64L156.47,159.6a5,5,0,0,0-9.68.69L121.45,307.38l-19.69-96.87a5,5,0,0,0-9.53-.9L76.36,248.48H12.08a243.15,243.15,0,0,1,71.38-165ZM350.57,368.42V428H160.86V368.42a3.59,3.59,0,0,1,2.83-3.51c.25,0,.5,0,.75,0H347c.25,0,.5,0,.75,0A3.59,3.59,0,0,1,350.57,368.42ZM160.86,351.37v-56a3.58,3.58,0,0,1,3.58-3.59H347a3.59,3.59,0,0,1,3.58,3.59v56a3.58,3.58,0,0,1-2.83,3.5c-.25,0-.5,0-.75,0H164.44c-.25,0-.5,0-.75,0A3.58,3.58,0,0,1,160.86,351.37Zm52.21-134.86h137.5V257H160.86V216.51ZM252.84,98h5.75v13.4h-5.75Zm0,18.4h5.75V178h-5.75ZM268.14,188v2.09H243.29V188Zm20.22,12.57v5.94H223.07v-5.94Zm24.29,5.94,6.07-25.34L328,206.51ZM326.18,267v14.79H185.25V267Zm5,14.79V267h7.64v14.79ZM180.25,267v14.79h-7.64V267ZM347,281.78h-3.17V267h6.37L358,287.47A13.53,13.53,0,0,0,347,281.78Zm81.58,146.76A243.95,243.95,0,0,1,12,258.48H79.71a5,5,0,0,0,4.63-3.11l10.91-26.69L117,335.48a5,5,0,0,0,4.9,4h.07a5,5,0,0,0,4.85-4.15L153.2,182l7.93,24.53H150.86V267h16.75v14.79h-3.17a13.6,13.6,0,0,0-13.58,13.59v56a13.47,13.47,0,0,0,3,8.52,13.52,13.52,0,0,0-3,8.53V438H360.57V368.42a13.52,13.52,0,0,0-3-8.53,13.47,13.47,0,0,0,3-8.52v-56a13.18,13.18,0,0,0-.07-1.41l11.26,29.46a5,5,0,0,0,4.67,3.21h.42a5,5,0,0,0,4.48-4l15.31-77.36L406,283.77a5,5,0,0,0,9.21,1.28l12.38-21.85h72.34a243,243,0,0,1-71.36,165.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.65,339.31a15.94,15.94,0,1,0-15.94-15.94A16,16,0,0,0,192.65,339.31Zm0-21.88a5.94,5.94,0,1,1-5.94,5.94A5.94,5.94,0,0,1,192.65,317.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.27,379.63a15.94,15.94,0,1,0,15.94,15.94A16,16,0,0,0,319.27,379.63Zm0,21.88a5.94,5.94,0,1,1,5.94-5.94A6,6,0,0,1,319.27,401.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.71,
    y: 393.07,
    width: 88.86,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.71,
    y: 405.92,
    width: 88.86,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.71,
    y: 380.37,
    width: 88.86,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 241.71,
    y: 319.13,
    width: 88.86,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 241.71,
    y: 331.98,
    width: 88.86,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 241.71,
    y: 306.43,
    width: 88.86,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 171.34,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 191.7,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.05,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 232.41,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 252.77,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 273.13,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 293.48,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 313.84,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 334.2,
    y: 222.34,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 171.34,
    y: 239.77,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 191.7,
    y: 239.77,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.05,
    y: 239.77,
    width: 10.18,
    height: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 232.41,
    y: 242.33,
    width: 111.96,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 292.88,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 307.08,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 321.29,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 335.49,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 349.69,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 321.29,
    y: 133.88,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 307.08,
    y: 120.92,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 321.29,
    y: 120.92,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 335.49,
    y: 120.92,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 300.11,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 314.31,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 328.51,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 342.72,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 321.54,
    y: 56.14,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 335.74,
    y: 69.1,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 321.54,
    y: 69.1,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 307.33,
    y: 69.1,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 342.72,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 328.51,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 314.31,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 300.11,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.21,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.41,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.61,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 197.82,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.02,
    y: 95.01,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.61,
    y: 133.88,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.41,
    y: 120.92,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.61,
    y: 120.92,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 197.82,
    y: 120.92,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 162.43,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 176.64,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 190.84,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.04,
    y: 107.96,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.86,
    y: 56.14,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.07,
    y: 69.1,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.86,
    y: 69.1,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.66,
    y: 69.1,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.04,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 190.84,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 176.64,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 162.43,
    y: 82.05,
    width: 7.1,
    height: 7.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensidadInstrumentalBlanco);
export default __webpack_public_path__ + "static/media/intensidad_instrumental_blanco.e7d3cb67f2ab2cb7dfab292de51ee876.svg";
export { ForwardRef as ReactComponent };